import { BREAKPOINTS } from 'constants/common';

export const getIsMobile = () => {
  // isMobile if width < than min tablet width
  return window.screen.width < BREAKPOINTS.tablet || window?.innerWidth < BREAKPOINTS.tablet;
};
